import {
  useGetSearchTypeQuery,
  useUpdateSearchTypeMutation,
} from "../../../../redux/api/BaseApi";
//import { RSSValue } from "react-smart-select";
import { ISearchType } from "../../../../types/ISearch";
import CustomSmartSelect from "../../../DropdownCheckbox/CustomSmartSelect";
import { CSSProperties, ReactNode } from "react";

type RSSLabel = string | ReactNode;
type RSSOption = {
  label: RSSLabel;
  value: any;
  [key: string]: any;
};
type RSSOptions = Array<RSSOption>;
type RSSValue = RSSOptions | RSSOption | null;


const countItems = (valueCount: number, optionCount: number): string => {
  switch (valueCount) {
    case 0:
      return "No items checked";
    case 1:
      return "1 item checked";
    case optionCount:
      return "All items checked";
    default:
      return `${valueCount} items checked`;
  }
};

const CheckBoxDropdownFilter = () => {
  const { data, isLoading, error } = useGetSearchTypeQuery();
  const [updateSearchTypeMutation] = useUpdateSearchTypeMutation();
  if (error) {
    console.log(error);
    return <div>Error</div>;
  }
  const allOptions = isLoading
    ? []
    : data
      .filter((item) => {
        return item.ID !== 28;
      })
      .map((item) => {
        return { ...item, label: item.Display, value: item.ID };
      });
  const CheckAll = { label: "Check All Filters", value: 1000 };
  allOptions.unshift({
    ID: CheckAll.value,
    label: CheckAll.label,
    Display: CheckAll.label,
    value: CheckAll.value,
    Order: -100,
    Checked: false,
  });
  const checkedOptions: RSSValue = allOptions.filter((item) => {
    return item.Checked;
  });
  allOptions[0].Checked = allOptions.length - 1 === checkedOptions.length;
  const finalOptions = allOptions.filter((item) => {
    return item.Checked;
  });
  const customSmartSelectStyle: CSSProperties = {
    fontSize: ".7rem",
    borderRadius: "0px",
    width: "24px",
  };
  const customSmartSelectLabelStyle: CSSProperties = {
    height: "30px",
    backgroundColor: "#868586",
    color: "#f0f0f0",
    border: "none",
    display: "grid",
    placeContent: "center",
  };
  const divWrapperStyle = "w-[24px] relative";
  if (isLoading) {
    return (
      <div className={divWrapperStyle}>
        <CustomSmartSelect
          toggle
          value={finalOptions}
          style={customSmartSelectStyle}
          labelStyle={customSmartSelectLabelStyle}
          onChange={() => console.log("Loading values")}
          options={allOptions}
        />
      </div>
    );
  }
  return (
    <div className={divWrapperStyle}>
      <CustomSmartSelect
        toggle
        value={finalOptions}
        style={customSmartSelectStyle}
        labelStyle={customSmartSelectLabelStyle}
        optionStyle={{
          border: "none",
          height: "30px",
          width: "220px",
          paddingTop: "2px",
          paddingLeft: "4px",
          fontWeight: "normal",
          backgroundColor: "#868586",
          color: "#f0f0f0",
          fontSize: ".85rem",
        }}
        formatLabel={(value, options) =>
          countItems(value.length, options.length)
        }
        options={allOptions}
        onChange={(value, selected, options) => {
          if (selected.value === CheckAll.value) {
            const checkAllOptions = data.map((item) => {
              return { ...item, Checked: !allOptions[0].Checked };
            });
            updateSearchTypeMutation(checkAllOptions);
          } else {
            const update: ISearchType = {
              ID: selected.ID,
              Display: selected.Display,
              Checked: !selected.Checked,
              Order: selected.Order,
            };
            updateSearchTypeMutation([update]);
          }
        }}
      />
    </div>
  );
};
export default CheckBoxDropdownFilter;
